<template>
  <div
    v-if="hasOptions"
    class="v2-products-filter"
  >
    <div
      v-for="(values, key) in options"
      :key="key"
      class="v2-products-filter__group"
    >
      <v2-dropdown
        v-if="values && values.length"
        :options="values"
        :value="null"
        :placeholder="formatLabel(key) + (getCount(key) ? ` (${getCount(key)})` : '')"
        :searchable="false"
        @select="onSelectOption(key, $event)"
      >
        <template #option="{ option }">
          <div class="v2-products-filter__option">
            <span>{{ formatOption(option) }}</span>
            <svg
              v-if="isSelected(key, option)"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="v2-products-filter__check"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
        </template>
      </v2-dropdown>
    </div>
  </div>
</template>

<script>
import V2Dropdown from '@/components/v2/V2Dropdown.vue'

const filterDropdownKey = {
  STATUS: 'status',
  DEPARTMENT: 'department',
  CATEGORY: 'category',
  SUB_CATEGORY: 'subCategory',
}

const MODIFIED_ITEMS = 'Modified items'

export default {
  name: 'V2OrderProductsFilter',
  components: { V2Dropdown },
  props: {
    orderProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {},
      selectedOptions: {},
    }
  },
  computed: {
    hasOptions() {
      return Object.values(this.options).some(v => v && v.length)
    },
  },
  created() {
    this.initializeFilterOptions()
  },
  methods: {
    initializeFilterOptions() {
      this.options = this.getFilterOptionValues(this.orderProducts)
      this.selectedOptions = this.getDefaultOptions()
    },
    getDefaultOptions() {
      const obj = {}
      Object.values(filterDropdownKey).forEach(key => {
        obj[key] = []
      })
      return obj
    },
    getFilterOptionValues(products = []) {
      const opts = this.getDefaultOptions()
      products.forEach(product => {
        Object.keys(opts).forEach(key => {
          const val = product?.[key]
          if (val && !opts[key].includes(val)) {
            opts[key].push(val)
          }
        })
      })
      opts[filterDropdownKey.STATUS].push(MODIFIED_ITEMS)
      return opts
    },
    formatLabel(key) {
      if (key === 'subCategory') return 'Sub Category'
      return key.charAt(0).toUpperCase() + key.slice(1)
    },
    formatOption(option) {
      if (!option) return ''
      return option.charAt(0).toUpperCase() + option.slice(1)
    },
    getCount(key) {
      return this.selectedOptions[key]?.length || 0
    },
    isSelected(key, option) {
      return this.selectedOptions[key]?.includes(option)
    },
    onSelectOption(key, value) {
      if (!key || !value) return
      if (!this.selectedOptions[key].includes(value)) {
        this.selectedOptions[key].push(value)
      } else {
        this.selectedOptions[key] = this.selectedOptions[key].filter(v => v !== value)
      }
      this.filterProducts()
    },
    filterProducts() {
      let filtered = this.orderProducts
      Object.keys(this.selectedOptions).forEach(key => {
        if (this.selectedOptions[key].length) {
          filtered = filtered.filter(product => {
            const filterKeys = this.selectedOptions[key].filter(k => k !== MODIFIED_ITEMS)
            const included = filterKeys.includes(product[key])
            if (key === filterDropdownKey.STATUS && this.selectedOptions[key].includes(MODIFIED_ITEMS)) {
              return product.isEdited || included
            }
            return included
          })
        }
      })
      const isEmpty = !Object.values(this.selectedOptions).some(v => v?.length)
      if (isEmpty) {
        this.$emit('on-apply-filter', false)
      } else {
        this.$emit('on-apply-filter', true, filtered)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-products-filter {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  &__group {
    width: 200px;
  }

  &__option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__check {
    color: var(--v2-primary);
    flex-shrink: 0;
  }
}
</style>
